import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

import DropZone from 'components/Shared/DropZone';
import InfoSuiviColis from 'components/Shared/InfoSuiviColis';
import PieceGestionSearch from 'components/Shared/PieceGestionSearch';
import DepannageDirectClient from 'components/Shared/DepannageDirectClient';

import { ReclamationQualificationDetailType } from 'constants.js';
import { ReclamationQualificationDetailCodes } from 'constants.js';
import { TypeCodes } from 'constants.js';

const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    row: {
        flexBasis: '100%',
        marginBottom: '10px'
    },
    formControl: {
        margin: theme.spacing(1)
    },
    group: {
        margin: theme.spacing(1, 0)
    },
    heightLabel: {
        height: '30px'
    }
});

const Etape = {
    ChoixDeLaPiece: 0,
    Qualifications: 1
};

class AucunColisArriveStep extends React.Component {
    state = {
        expandedPanel: 'panelPiece',
        etape: Etape.ChoixDeLaPiece
    };

    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante ou le bouton de création.
        const { reclamation, onNextStepValid } = this.props;

        // Si une ligne de détail avec le code SuiviColisVerifie
        let nextStepValid = false;
        if (reclamation !== null && reclamation.qualificationDetails.length > 0) {
            const suiviColisVerifie = this.getSuiviColisVerifie();
            if (suiviColisVerifie !== '' &&
                reclamation.numeroPiece.length > 0) {
                nextStepValid = true;
            }
        }

        onNextStepValid(nextStepValid);
    }

    getSuiviColisVerifie() {
        const { reclamation } = this.props;

        let suiviColisVerifie = '';

        const detailSuiviColisVerifie = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.SuiviColisVerifie);
        if (detailSuiviColisVerifie !== undefined) {
            suiviColisVerifie = detailSuiviColisVerifie.valeurInteger;
        }

        return suiviColisVerifie;
    }

    getDepannageDirectClient() {
        const { reclamation } = this.props;

        let depannageDirectClient = '';

        const detailDepannageDirectClient = reclamation.qualificationDetails.find(detail => detail.code === ReclamationQualificationDetailCodes.DepannageDirectClient);
        if (detailDepannageDirectClient !== undefined) {
            depannageDirectClient = detailDepannageDirectClient.valeurBool;
        }

        return depannageDirectClient;
    }

    checkErrors(suiviColisVerifie, depannageDirectClient) {
        const { reclamation, utilisateurMagasin } = this.props;

        let errors = [];
        if (suiviColisVerifie === '') {
            errors.push({ key: ReclamationQualificationDetailCodes.SuiviColisVerifie, errorMsg: 'Le suivi colis a-t-il été vérifié ?' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.SuiviColisVerifie, errorMsg: null });
        }

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            if (depannageDirectClient === '') {
                errors.push({ key: ReclamationQualificationDetailCodes.DepannageDirectClient, errorMsg: 'Avez-vous résolu le problème de votre client ?' });
            } else {
                errors.push({ key: ReclamationQualificationDetailCodes.DepannageDirectClient, errorMsg: null });
            }
        }

        if (reclamation.numeroPiece.length === 0) {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: 'Veuillez sélectionner une pièce.' });
        } else {
            errors.push({ key: ReclamationQualificationDetailCodes.Piece, errorMsg: null });
        }

        return errors;
    }

    handleChangePanel = panel => (event, expandedPanel) => {
        this.setState({
            expandedPanel: expandedPanel ? panel : false
        });
    }

    handleChange = (event) => {
        const { onChange } = this.props;

        const suiviColisVerifie = this.getSuiviColisVerifie();
        const depannageDirectClient = this.getDepannageDirectClient();
        const errors = this.checkErrors(suiviColisVerifie, depannageDirectClient);

        onChange(event, errors);
    }

    handleSelectPiece = (value) => {
        const { onSelectPiece } = this.props;

        // On ouvre le panel avec les détails de la qualification.
        this.setState({
            expandedPanel: 'panelQualificationDetails',
            etape: Etape.Qualifications
        });

        const suiviColisVerifie = this.getSuiviColisVerifie();
        const depannageDirectClient = this.getSuiviColisVerifie();
        const errors = this.checkErrors(suiviColisVerifie, depannageDirectClient);

        // On met à jour le numéro de pièce sur la réclamation.
        onSelectPiece(value, errors, false);
    }

    handleDetailSuiviColisVerifieChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 0,
            code: ReclamationQualificationDetailCodes.SuiviColisVerifie,
            type: ReclamationQualificationDetailType.ChoixSimple,
            libelle: 'Avez-vous vérifié votre suivi colis ?',
            valeurInteger: event.target.value,
            valeurString: event.target.labels[0].innerText
        };

        const suiviColisVerifie = event.target.value;
        const depannageDirectClient = this.getDepannageDirectClient();
        const errors = this.checkErrors(suiviColisVerifie, depannageDirectClient);

        onDetailChange(qualificationDetail, errors, null);
    }

    handleQualificationDetailsDepannageDirectClientChange = (event) => {
        const { onDetailChange } = this.props;

        const qualificationDetail = {
            position: 1,
            code: ReclamationQualificationDetailCodes.DepannageDirectClient,
            type: ReclamationQualificationDetailType.Booleen,
            libelle: 'Avez-vous résolu le problème de votre client ?',
            valeurBool: event.target.value
        };

        const suiviColisVerifie = this.getSuiviColisVerifie();
        const depannageDirectClient = event.target.value;
        const errors = this.checkErrors(suiviColisVerifie, depannageDirectClient);

        onDetailChange(qualificationDetail, errors, null);
    }

    renderSuiviColis() {
        const { classes, reclamation } = this.props;

        const detailSuiviColisVerifieValue = this.getSuiviColisVerifie();

        if (reclamation.numeroPiece !== '') {
            return (<FormControl component="fieldset" className={classes.formControl} required>
                <FormLabel component="legend">
                    Avez-vous vérifié votre suivi colis ?
                    <InfoSuiviColis
                        numeroPiece={reclamation.pieceCle || reclamation.numeroPiece}
                        afficheSuiviColisDetaille
                    />
                </FormLabel>
                <RadioGroup
                    name="SUIVI_COLIS_VERIFIE"
                    className={classes.group}
                    value={detailSuiviColisVerifieValue}
                    onChange={this.handleDetailSuiviColisVerifieChange}
                >
                    <FormControlLabel className={classes.heightLabel} value="0" control={<Radio />} label="Oui, j'ai trouvé les informations souhaitées (dossier après-vente cloturé automatiquement)." />
                    <FormControlLabel className={classes.heightLabel} value="1" control={<Radio />} label="Oui, mais je souhaite plus d'informations." />
                    <FormControlLabel className={classes.heightLabel} value="2" control={<Radio />} label="Non." />
                </RadioGroup>
            </FormControl>
            );
        } else {
            return null;
        }
    }

    renderDepannageDirectClient() {
        const { reclamation, utilisateurMagasin } = this.props;

        const detailDepannageDirectClientValue = this.getDepannageDirectClient();

        if (reclamation.type.code === TypeCodes.Client && utilisateurMagasin) {
            return (
                <DepannageDirectClient
                    onDetailChange={this.handleQualificationDetailsDepannageDirectClientChange}
                    value={detailDepannageDirectClientValue}
                />
            );
        } else {
            return null;
        }
    }

    render() {
        const { classes, reclamation, namespace } = this.props;
        const { etape, expandedPanel } = this.state;

        return (
            <React.Fragment>

                <div className={classes.row}>
                    <TextField
                        multiline
                        fullWidth
                        name="commentaire"
                        label="Commentaire"
                        placeholder="Décrire le problème rencontré"
                        maxRows="3"
                        onChange={this.handleChange}
                        value={reclamation.commentaire}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                </div>

                <div className={classes.row}>
                    <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} />
                </div>


                <div className={classes.row}>
                    <Accordion expanded={expandedPanel === 'panelPiece'} onChange={this.handleChangePanel('panelPiece')}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            className={classes.panelSummary}
                        >
                            <Typography >Rechercher une pièce*</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <PieceGestionSearch
                                onSelectPiece={this.handleSelectPiece}
                                client={reclamation.client}
                                withLignes={false}
                                namespace={namespace}
                                warningReclamation
                                defautProduitInfos={false}
                                logistiqueInfos={false}
                                warningLivraison
                                defautNumeroPiece={reclamation.numeroPiece}
                                disableMixLignesPositivesNegatives
                            />
                        </AccordionDetails>
                    </Accordion>

                    {reclamation.numeroPiece && etape === Etape.Qualifications && (
                        <>

                            <Accordion expanded={expandedPanel === 'panelQualificationDetails'} onChange={this.handleChangePanel('panelQualificationDetails')}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    className={classes.panelSummary}
                                >
                                    <Typography >Qualification</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <div className={classes.flexContainer}>
                                        <div className={classes.row}>
                                            {this.renderSuiviColis()}
                                        </div>
                                        <div className={classes.row}>
                                            {this.renderDepannageDirectClient()}
                                        </div>
                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        </>
                    )}


                </div>
            </React.Fragment>
        );
    }
}

AucunColisArriveStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onDetailChange: PropTypes.func.isRequired,
    onSelectPiece: PropTypes.func.isRequired,
    validationErrors: PropTypes.array,
    onNextStepValid: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired
};

export default withStyles(styles)(AucunColisArriveStep);